/*
  Journal sport tabs, without a page load.

  Each tab is a real link to /blogs/journal/tagged/<sport>, so it works with
  JavaScript off, with a middle click, and for a crawler. When script is
  available the target is fetched and the article grid is swapped in place,
  which removes the white flash and the jump back to the top of the page.

  Anything unexpected — a failed fetch, markup that does not match — falls back
  to following the link normally rather than leaving the reader stuck.
*/
(function () {
  'use strict';

  var GRID = '.main-blog';
  var TAB = '.blogsports__tab';
  var supported = 'fetch' in window && 'pushState' in window.history && 'DOMParser' in window;

  function grid() {
    return document.querySelector(GRID);
  }

  function setActive(pathname) {
    Array.prototype.forEach.call(document.querySelectorAll(TAB), function (a) {
      var on = a.getAttribute('href') === pathname;
      a.classList.toggle('is-active', on);
      if (on) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
  }

  function load(url, push) {
    var g = grid();
    if (!g) {
      window.location.href = url;
      return;
    }

    var pathname = url;
    try {
      pathname = new URL(url, window.location.origin).pathname;
    } catch (e) {}

    // The active tab moves immediately; only the list waits for the response.
    setActive(pathname);
    g.setAttribute('data-journal-loading', '');
    g.setAttribute('aria-busy', 'true');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('bad response');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(GRID);
        if (!fresh) throw new Error('no grid in response');

        g.innerHTML = fresh.innerHTML;
        if (push) window.history.pushState({ journal: true }, '', url);

        g.removeAttribute('data-journal-loading');
        g.setAttribute('aria-busy', 'false');

        // Let the theme re-run anything that hooks new markup.
        document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (event) {
    if (!supported) return;
    // Leave modified clicks alone so "open in new tab" still works.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    var tab = event.target.closest ? event.target.closest(TAB) : null;
    if (!tab) return;

    var href = tab.getAttribute('href');
    if (!href) return;

    event.preventDefault();
    if (href === window.location.pathname) return;
    load(href, true);
  });

  window.addEventListener('popstate', function () {
    if (!supported) return;
    if (!grid()) return;
    load(window.location.pathname, false);
  });
})();
